/** Descarga de la lámina como PNG o como PDF listo para impresión. */

/** El lado largo de una A3 en puntos PostScript (420 mm). */
const A3_LONG_SIDE_PT = 1190.55;

export function downloadPng(canvas, fileName) {
  const link = document.createElement('a');
  link.href = canvas.toDataURL('image/png');
  link.download = `${fileName}.png`;
  link.click();
}

/**
 * PDF de una sola página cuya hoja tiene EXACTAMENTE la proporción de la lámina.
 * No se fuerza a una A3 nominal: hacerlo dejaría franjas blancas a los lados y la
 * cenefa dejaría de coincidir con el borde del papel.
 *
 * jsPDF se carga bajo demanda: arrastra html2canvas y dompurify (~220 kB) que
 * esta app no usa, y quien sólo exporta PNG no tiene por qué descargarlos.
 */
export async function downloadPdf(canvas, fileName, metadata) {
  const { jsPDF } = await import('jspdf');

  const imageWidth = canvas.width;
  const imageHeight = canvas.height;
  const fit = A3_LONG_SIDE_PT / Math.max(imageWidth, imageHeight);
  const pageWidth = imageWidth * fit;
  const pageHeight = imageHeight * fit;

  const pdf = new jsPDF({
    orientation: pageWidth >= pageHeight ? 'landscape' : 'portrait',
    unit: 'pt',
    format: [pageWidth, pageHeight],
    compress: true,
  });

  pdf.addImage(
    canvas.toDataURL('image/png'),
    'PNG',
    0,
    0,
    pdf.internal.pageSize.getWidth(),
    pdf.internal.pageSize.getHeight(),
    undefined,
    'FAST',
  );

  pdf.setProperties({
    title: `Lámina cobertura DEA · ${metadata.sitio || fileName}`,
    subject: 'Espacio cardioprotegido · Ley 21.156 · D.S. 56/2020, Art. 5º',
    author: 'VitalHeart · VitalGroup',
    keywords: metadata.codigoDoc || '',
  });

  pdf.save(`${fileName}.pdf`);
}

/** Descarga el proyecto como `.json`, para respaldo o para moverlo de máquina. */
export function downloadJson(data, fileName) {
  const blob = new Blob([JSON.stringify(data)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${fileName}.json`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1500);
}
